import { Trans } from '@lingui/react/macro';

import { type PixelType } from '@/api/pixel';
import { ColorBadge } from '@/components/typography';
import { getChannelColor } from '@/constants/colors/channel';

type Props = {
  pixels?: PixelType[];
};

const PixelTagList = ({ pixels }: Props) => {
  return (
    <div className="flex flex-wrap justify-end gap-1">
      {pixels?.map((pixel) => {
        const channelColor = getChannelColor(pixel.channel, 0.5);

        return (
          <ColorBadge
            key={pixel.id}
            size="medium"
            variant="solid"
            color={channelColor}
            textColor="dark"
          >
            <Trans>
              {pixel.name} - {pixel.vendor.name} - {pixel.channel.name}
            </Trans>
          </ColorBadge>
        );
      })}
    </div>
  );
};

export default PixelTagList;
